import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { ShellComponent } from './shell.component';
import { AppbarModule } from '../appbar/appbar.module';
import { MenuModule } from '../menu/menu.module';

@NgModule({
  declarations: [ShellComponent],
  imports: [CommonModule, MenuModule, AppbarModule, RouterModule],
  exports: [ShellComponent]
})
export class SparkShellModule {}
